export default "skymp5-front/70828fb0d81d34baf7216b141e84512a.svg";